(function () {
  'use strict';

  angular.module('eclipseApp.cfa').config(['$stateProvider', function ($stateProvider) {
    $stateProvider
      .state('cfaLanding', {
        url: '/cfalanding?province&language&jSessionID&targetURL',
        parent: 'app',
        title: "cfaLanding",
        views: {
          content: {
            templateUrl: 'modules/cfa/views/cfaLanding.html',
            controller: 'cfaLandingCtrl'
          }
        }
      });
  }]);

})();
